import React from 'react';
import ChatMessageRow from './ChatMessageRow';
import ChatMessageContent from './ChatMessageContent';
import ChatLinkPreviewList from './ChatLinkPreviewList';
import {
  buildGroupMessageContentProps,
  buildGroupMessageRowViewModel,
} from './groupMessageRowViewUtils';
import ChatQuestionCard from '../questions/ChatQuestionCard';

export default function GroupStandardMessageRow({
  message,
  presentation,
  isSelf,
  variant = 'plain',
  selfBubbleClass,
  otherBubbleClass,
  timeLabel = '',
  rowClassName = '',
  activeAnchorMessageId,
  anchorClassName = 'is-anchor-hit',
  avatarClassName,
  avatarClickableClassName = '',
  avatarFallbackClassName,
  avatarFallbackStyle,
  avatarAlt = '',
  onAvatarClick,
  onContextMenu,
  onTouchStart,
  onTouchEnd,
  onTouchCancel,
  onTouchMove,
  onImageClick,
  onMentionClick,
  fileVariant = 'simple',
  bubbleClassName = '',
  sideActionContent = null,
  replyHeaderContent = null,
  wrapContent = null,
  footerContent = null,
  metaEndContent = null,
}) {
  const rowProps = buildGroupMessageRowViewModel({
    message,
    presentation,
    isSelf,
    variant,
    selfBubbleClass,
    otherBubbleClass,
    timeLabel,
    activeAnchorMessageId,
    anchorClassName,
    avatarClassName,
    avatarClickableClassName,
    avatarFallbackClassName,
    avatarFallbackStyle,
    avatarAlt,
    onAvatarClick,
    onContextMenu,
    onTouchStart,
    onTouchEnd,
    onTouchCancel,
    onTouchMove,
  });

  const contentNode = (
    <ChatMessageContent
      {...buildGroupMessageContentProps({
        message,
        presentation,
        onImageClick,
        onMentionClick,
        fileVariant,
      })}
    />
  );

  const linkPreviewCards = message?.linkPreview || message?.linkPreviews?.length
    ? <ChatLinkPreviewList message={message} />
    : null;
  const questionCard = message?.question ? <ChatQuestionCard question={message.question} /> : null;
  const mergedFooter = (linkPreviewCards || questionCard || footerContent)
    ? (<>{linkPreviewCards}{questionCard}{footerContent}</>)
    : null;

  return (
    <ChatMessageRow
      key={message?.id}
      {...rowProps}
      rowClassName={rowClassName}
      bubbleClassName={bubbleClassName ? `${rowProps.bubbleClassName || ''} ${bubbleClassName}`.trim() : rowProps.bubbleClassName}
      sideActionContent={sideActionContent}
      footerContent={mergedFooter}
      metaEndContent={metaEndContent}
    >
      <>
        {replyHeaderContent}
        {typeof wrapContent === 'function' ? wrapContent(contentNode, message) : contentNode}
      </>
    </ChatMessageRow>
  );
}
